import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Plan, PlanWithLimits, Subscription } from '../../../shared/models/plans';
import { PlansTableDefinition } from './plans-table.model';
import { Observable } from 'rxjs';
import { plansTables } from '../plan-features-definition';

@Component({
  selector: 'cc-plans-table',
  templateUrl: './plans-table.component.html',
  styleUrls: ['./plans-table.component.scss']
})
export class PlansTableComponent implements OnInit {
  @Input() public plans$: Observable<PlanWithLimits[]>;
  @Input() public currentSubscription: Subscription;
  @Input() public subscribeEnabled: (PlanWithLimits) => boolean;
  @Output() public subscribePlan = new EventEmitter<PlanWithLimits>();

  public mainTable: PlansTableDefinition;
  public secondaryTables: PlansTableDefinition[];

  public fullComparision = false;

  constructor() {}

  ngOnInit() {
    this.mainTable = plansTables[0];
    this.secondaryTables = plansTables
      .slice(1)
      .map(features => ({ ...features, rows: features.rows.filter(row => !row.hidden) }));
  }

  onSubscribePlan(plan: PlanWithLimits) {
    this.subscribePlan.emit(plan);
  }

  isCurrentSubscription(plan: Plan): boolean {
    return (
      this.currentSubscription &&
      this.currentSubscription.licenses &&
      this.currentSubscription.licenses.some(license => license.planId === plan.id)
    );
  }

  showFullComparision() {
    this.fullComparision = true;
  }
}
